import React from "react";
import { TextField, Typography, Paper } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";

const TabExpectedResults = (props) => {
  const { editMode, currentNode, handleChangeField, theme } = props;

  return (
    <div style={{ padding: 16 }}>
      <Paper style={{ padding: 16, minHeight: 350, display: 'flex', flexDirection: 'column', justifyContent: 'center', backgroundColor: theme?.theme === "dark" ? '#1e1f20' : "#f0f4f9" }}>
        <Typography className="whiteText" variant="subtitle1" style={{ marginBottom: 16 }}>
          {getLocalizedString("descriptionOfExpectedResults")}
        </Typography>
        <TextField
          fullWidth
          disabled={!editMode}
          multiline={true}
          rows={13}
          rowsMax={13}
          value={currentNode["expectedResults"] || ""}
          onChange={(e) => handleChangeField("expectedResults", e.target.value)}
          InputProps={{ className: "whiteText", style: { padding: 12 } }}
        />
      </Paper>
    </div>
  );
};

export default TabExpectedResults;
